import { render, staticRenderFns } from "./ModalDuplicate.vue?vue&type=template&id=880c5012&"
import script from "./ModalDuplicate.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./ModalDuplicate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports